var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVanuatu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M30 0H0v12h30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    d: "M30 24V12H0v12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "m16.5 9-13-9H0v24h3.5l13-9H30V9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdce12",
    d: "M0 0v2.5L13.5 12 0 21.5V24l15.5-11.08H30V11H15.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdce12",
    d: "M4.35 15.25s3-.46 3-3.42A2.85 2.85 0 0 0 4.54 9 2.5 2.5 0 0 0 2 11.54c0 1.61 1.5 2.11 2.23 2.11s1.85-.57 1.7-1.84c-.44 1.76-2.23 1.71-2.93.65-.77-1.17.42-2.85 1.96-2.38C6.42 10.5 6.5 12 6 12.92c-.62 1.16-1.63 1.1-1.63 1.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdce12",
    d: "M5.27 11.94a4 4 0 0 0-.59-.6c.46-.47.84-.6.72-.67-.08-.04-.5.15-.96.48-.45-.33-.88-.52-.96-.48-.12.07.27.2.72.67q-.31.27-.58.6c-.19.24-.16.66-.16.66s.25-.1.46-.31c.18-.17.32-.41.52-.67q.28.4.52.67c.22.2.46.3.46.3s.03-.4-.15-.65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanuatu);
export default __webpack_public_path__ + "static/media/vanuatu.6cf427366a5d1e3532c72270fa4fe1f8.svg";
export { ForwardRef as ReactComponent };